import { dispatch, getState } from "../../state/store";
import {
  removeLoadingLocationId,
  setLoadingLocationId,
  setLocations,
  setLocationsError
} from "../../state/ducks";
import { selectLocations } from "../../state/selectors";

import { strCode } from "../../consts";
import { locationsService, notificationService, t } from "../../services";
import { responseUtil } from "../../utils";

export const useSaveStore = () => {
  const mutationCallback = async (id, storeData, market) => {
    dispatch(setLoadingLocationId(id));
    dispatch(setLocationsError(null));

    try {
      storeData.market = market;
      storeData.address = storeData?.address ?? null;

      if (id === -1) {
        const locationsByMarket = selectLocations(market)(getState()) ?? [];

        if (!locationsByMarket.some((location) => location.id === -1)) {
          dispatch(
            setLocations({ market, locations: [{ id, ...storeData }, ...locationsByMarket] })
          );
        }

        delete storeData.id;

        const res = await locationsService.createNewLocation(storeData);

        if (responseUtil.isResponseSuccessful(res)) {
          notificationService.showSuccess({
            title: t(strCode.CREATE_LOCATION_SUCCESS_TITLE),
            message: t(strCode.CREATE_LOCATION_SUCCESS_MESSAGE)
          });
        }
      } else {
        storeData.id = id;
        const res = await locationsService.updateLocation(storeData);

        if (responseUtil.isResponseSuccessful(res)) {
          notificationService.showSuccess({
            title: t(strCode.EDIT_LOCATION_SUCCESS_TITLE),
            message: t(strCode.EDIT_LOCATIONS_SUCCESS_MESSAGE)
          });
        }
      }
    } catch (err) {
      dispatch(setLocationsError(err));

      throw err;
    } finally {
      dispatch(removeLoadingLocationId(id));
      dispatch(setLocationsError(false));
    }
  };

  return { mutationCallback };
};
